import React from "react";

import { Box, FormControlLabel, Switch, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useAppDispatch, useAppSelector } from "store";

import SimpleTooltip from "components/SimpleTooltip";
import { SimpleTooltipPlacement } from "components/SimpleTooltip";
import {
    selectShowAlternateCategoryCompetitors,
    toggleShowAlternateCategoryCompetitors
} from "modules/customer/tools/location/competitionNew/competitionSlice";

const StyledSwitch = withStyles(theme => ({
    switchBase: {
        "&$checked": {
            // @ts-ignore
            color: theme.palette.tertiary.main,
        },
        "&$checked + $track": {
            // @ts-ignore
            backgroundColor: theme.palette.tertiary.main
        }
    },
    checked: {},
    track: {}
}))(Switch);

const AlternateCategoriesSwitch: React.FC = () => {
    const dispatch = useAppDispatch();
    const showAlternateCategoryCompetitors = useAppSelector(selectShowAlternateCategoryCompetitors);

    const onChange = () => {
        dispatch(toggleShowAlternateCategoryCompetitors());
    };

    const probabilitySwitch = (<StyledSwitch
        size="small"
        color="default"
        checked={showAlternateCategoryCompetitors}
        onChange={onChange}
    />);

    return (
        <Box display="flex" padding={1}>
            <FormControlLabel
                control={probabilitySwitch}
                label="Show alternate category stores"
            />
            <SimpleTooltip
                placement={SimpleTooltipPlacement.Right}
                title={
                    <Typography variant="body1" component="div">
                        Include stores which have your selected competitor
                        store categroies as an alternate category
                    </Typography>
                }
            >
                <InfoOutlinedIcon color="disabled" cursor="pointer" />
            </SimpleTooltip>
        </Box>
    );
};

export default AlternateCategoriesSwitch;
